var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 14,
    viewBox: "0 0 9 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Line 42",
    d: "M4.14645 13.8536C4.34171 14.0488 4.65829 14.0488 4.85355 13.8536L8.03553 10.6716C8.2308 10.4763 8.2308 10.1597 8.03553 9.96447C7.84027 9.7692 7.52369 9.7692 7.32843 9.96447L4.5 12.7929L1.67157 9.96447C1.47631 9.7692 1.15973 9.7692 0.964466 9.96447C0.769204 10.1597 0.769204 10.4763 0.964466 10.6716L4.14645 13.8536ZM4 0.5L4 13.5H5L5 0.5L4 0.5Z",
    fill: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLess);
export default __webpack_public_path__ + "static/media/less.851f244cda4aa09b7ced964236bf2085.svg";
export { ForwardRef as ReactComponent };